import React from "react";
import { Card } from "reactstrap";
import { Trans } from "react-i18next";
import numeral from "numeral";

const SummaryCard = ({ title, value, children }) => {
  const numeralValue = numeral(value).format("0,0.00");
  return (
    <Card body className="text-center mx-2 px-0">
      <div style={{ fontSize: "80%" }} className="mb-1">
        <Trans>{title}</Trans>
      </div>
      {children || <div className="h6">
        {title === 'Deductions' ? `(${numeralValue})` : numeralValue}</div>}
    </Card>
  );
};

export default SummaryCard;
